/**
 * Categories CRUD — Firestore + dev mode mirror.
 */
import { addDoc, collection, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { db, COLLECTIONS, IS_DEV_MODE } from '../../lib/firebase';
import { useCategoriesStore, type Category } from './categoriesStore';
import { generateId } from '../../lib/utils';

export interface NewCategoryInput {
  familyId: string;
  name: string;
  icon: string;
  color: string;
  type: 'income' | 'expense';
  order?: number;
}

export async function createCategory(input: NewCategoryInput): Promise<string> {
  if (IS_DEV_MODE) {
    const id = generateId('cat');
    const c: Category = {
      id,
      familyId: input.familyId,
      name: input.name,
      icon: input.icon,
      color: input.color,
      type: input.type,
      isDefault: false,
      order: input.order ?? 999,
    };
    const store = useCategoriesStore.getState();
    store.setCategories([...store.categories, c]);
    return id;
  }
  const ref = await addDoc(collection(db, COLLECTIONS.categories), {
    familyId: input.familyId,
    name: input.name,
    icon: input.icon,
    color: input.color,
    type: input.type,
    isDefault: false,
    order: input.order ?? 999,
  });
  return ref.id;
}

export async function updateCategory(id: string, patch: Partial<NewCategoryInput>): Promise<void> {
  if (IS_DEV_MODE) {
    const store = useCategoriesStore.getState();
    store.setCategories(store.categories.map((c) => (c.id === id ? { ...c, ...patch } : c)));
    return;
  }
  await updateDoc(doc(db, COLLECTIONS.categories, id), patch);
}

export async function deleteCategory(id: string): Promise<void> {
  if (IS_DEV_MODE) {
    const store = useCategoriesStore.getState();
    store.setCategories(store.categories.filter((c) => c.id !== id));
    return;
  }
  await deleteDoc(doc(db, COLLECTIONS.categories, id));
}
